import { Image } from "@/type/core/image/image.types";
import React, { createContext, useContext, useState } from "react";

interface UserPictureContextType {
  avatar?: Image;
  setAvatar: (avatar?: Image) => void;
}

const UserPictureContext = createContext<UserPictureContextType | undefined>(
  undefined,
);

export const UserPictureProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [avatar, setAvatar] = useState<Image | undefined>(undefined);

  return (
    <UserPictureContext.Provider value={{ avatar, setAvatar }}>
      {children}
    </UserPictureContext.Provider>
  );
};

export const useUserPictureContext = (): UserPictureContextType => {
  const context = useContext(UserPictureContext);
  if (!context) {
    throw new Error(
      "useUserPictureContext must be used within a UserPictureProvider",
    );
  }
  return context;
};
